import React, { useState } from 'react';

import Button from '@components/common/Button/Button';
import ThankForm from '@components/lpc/Pot/AmountModule/ThankParticipants/ThankForm/ThankForm';

import css from './ThankParticipants.module.scss';

type ThanksParticipantsProps = {
    potRef: string;
    potTitle: string;
    customClass?: string;
    buttonVariant: string;
    wordingCta?: string;
    isVisible: boolean;
    showIcon?: boolean;
};

const ThankParticipants = ({
    potRef,
    potTitle,
    isVisible,
    buttonVariant,
    customClass,
    wordingCta,
    showIcon,
}: ThanksParticipantsProps) => {
    const [openForm, setOpenForm] = useState<boolean>(false);

    return (
        <>
            <ThankForm potRef={potRef} potTitle={potTitle} isVisible={openForm} onHide={() => setOpenForm(false)} />

            {isVisible && (
                <div className={`${css.thanks} ${customClass}`}>
                    <Button onClick={() => setOpenForm(true)} variant={buttonVariant} customClass={css.thanks__cta}>
                        <div className={css.thanks__cta__content}>
                            {wordingCta}
                            {showIcon && (
                                <img
                                    className={css.thanks__cta__img}
                                    src="/front-static/icons/display/pink-heart.png"
                                    alt="spend"
                                />
                            )}
                        </div>
                    </Button>
                </div>
            )}
        </>
    );
};

export default ThankParticipants;
